import request from '@/utils/request'

// 配置接口
export function getDefaultSetting (data) {
  return request({
    url: '/getDefaultSetting',
    method: 'post',
    data
  })
}
// 打折页面查询
export function selediscount (data) {
  return request({
    url: '/discount/selediscount',
    method: 'post',
    data
  })
}
// 权限查询
export function access (data) {
  return request({
    url: '/settings/access',
    method: 'post',
    data
  })
}
// 折扣类型查询
export function seletypediscount (data) {
  return request({
    url: '/discount/seletypediscount',
    method: 'post',
    data
  })
}
// 添加折扣和比例
export function adddiscount (data) {
  return request({
    url: '/discount/adddiscount',
    method: 'post',
    data
  })
}
// 添加折扣和比例
export function updatediscount (data) {
  return request({
    url: '/discount/updatediscount',
    method: 'post',
    data
  })
}
// 打折删除
export function deletediscount (data) {
  return request({
    url: '/discount/deletediscount',
    method: 'post',
    data
  })
}
// 设置查询接口
export function getButtonsByStore (data) {
  return request({
    url: '/button/getButtonsByStore',
    method: 'post',
    data
  })
}
// 修改营业设置
export function operation (data) {
  return request({
    url: '/Settings/operation',
    method: 'post',
    data
  })
}
// 排序
export function sort (data) {
  return request({
    url: '/discount/sort',
    method: 'post',
    data
  })
}
// 首页功能设置
export function selehome (data) {
  return request({
    url: '/Settings/selehome',
    method: 'post',
    data
  })
}
// 首页功能修改
export function updatehome (data) {
  return request({
    url: '/Settings/updatehome',
    method: 'post',
    data
  })
}
// 首页功能修改
export function seletypebutton (data) {
  return request({
    url: '/Settings/seletypebutton',
    method: 'post',
    data
  })
}
// 右侧点单修改
export function updatetypebutton (data) {
  return request({
    url: '/Settings/updatetypebutton',
    method: 'post',
    data
  })
}
// 点单右侧按钮排序
export function buttonsort (data) {
  return request({
    url: '/Settings/buttonsort',
    method: 'post',
    data
  })
}
// 付款按钮查询
export function paymentbutton (data) {
  return request({
    url: '/Settings/paymentbutton',
    method: 'post',
    data
  })
}
// 付款按钮查询
export function updatepaymentbutton (data) {
  return request({
    url: '/Settings/updatepaymentbutton',
    method: 'post',
    data
  })
}
// 付款按钮查询
export function deletepaymentbutton (data) {
  return request({
    url: '/Settings/deletepaymentbutton',
    method: 'post',
    data
  })
}
// 付款按钮添加
export function addpaymentbutton (data) {
  return request({
    url: '/Settings/addpaymentbutton',
    method: 'post',
    data
  })
}
// 首页客户类型功能修改
export function updateCustomer (data) {
  return request({
    url: '/Settings/updateCustomer',
    method: 'post',
    data
  })
}
// 查询首页点单类型
export function seleCustomer (data) {
  return request({
    url: '/Settings/seleCustomer',
    method: 'post',
    data
  })
}
// 付款按钮排序接口
export function paymentbuttonsort (data) {
  return request({
    url: '/Settings/paymentbuttonsort',
    method: 'post',
    data
  })
}
// 首页功能排序

export function homesort (data) {
  return request({
    url: '/Settings/homesort',
    method: 'post',
    data
  })
}
// 首页客户类型排序

export function Customersort (data) {
  return request({
    url: '/Settings/Customersort',
    method: 'post',
    data
  })
}
// 按钮排序
export function typebuttonsort (data) {
  return request({
    url: '/Settings/typebuttonsort',
    method: 'post',
    data
  })
}
// 查询刷卡器信息
export function selectpax (data) {
  return request({
    url: '/Settings/selectpax',
    method: 'post',
    data
  })
}
// 添加刷卡器
export function addpax (data) {
  return request({
    url: '/Settings/addpax',
    method: 'post',
    data
  })
}
// 刷卡器信息修改
export function updatepax (data) {
  return request({
    url: '/Settings/updatepax',
    method: 'post',
    data
  })
}
// 修改为本机刷卡器
export function succpax (data) {
  return request({
    url: '/Settings/succpax',
    method: 'post',
    data
  })
}
// 删除刷卡器
export function deletepax (data) {
  return request({
    url: '/Settings/deletepax',
    method: 'post',
    data
  })
}
// 查询打印设置
export function selectprint (data) {
  return request({
    url: '/Settings/selectprint',
    method: 'get',
    data
  })
}
// 修改打印设置
export function updateprint (data) {
  return request({
    url: '/Settings/updateprint',
    method: 'post',
    data
  })
}
// 查询打印机设置
export function selectprinter (data) {
  return request({
    url: '/Settings/selectprinter',
    method: 'get',
    data
  })
}
// 添加打印机设置
export function addprinter (data) {
  return request({
    url: '/Settings/addprinter',
    method: 'post',
    data
  })
}
// 修改打印机设置
export function updateprinter (data) {
  return request({
    url: '/Settings/updateprinter',
    method: 'post',
    data
  })
}
// 删除打印机设置
export function deleteprinter (data) {
  return request({
    url: '/Settings/deleteprinter',
    method: 'post',
    data
  })
}
// 套餐卡添加
export function addPackagecard (data) {
  return request({
    url: '/Settings/addPackagecard',
    method: 'post',
    data
  })
}
// 查询所有套餐卡
export function selePackagecard (data) {
  return request({
    url: '/Settings/selePackagecard',
    method: 'post',
    data
  })
}
// 套餐卡修改
export function updatePackagecard (data) {
  return request({
    url: '/Settings/updatePackagecard',
    method: 'post',
    data
  })
}
// 删除套餐卡
export function deletePackagecard (data) {
  return request({
    url: '/Settings/deletePackagecard',
    method: 'post',
    data
  })
}
// 套餐卡状态修改
export function Packstatus (data) {
  return request({
    url: '/Settings/Packstatus',
    method: 'post',
    data
  })
}
